import { motion } from "framer-motion";
import { PAYMENT_SCHEDULE } from "../../data/project";

export default function PaymentPlan() {
  return (
    <section
      id="payment"
      data-testid="payment-section"
      className="relative bg-[#F4F2EC] py-24 md:py-36 border-t hairline"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-14">
          <div className="col-span-12 md:col-span-6">
            <div className="overline mb-5">04 / Payment Plan</div>
            <h2
              className="font-serif leading-[1.02] tracking-tight text-[#1A3626]"
              style={{ fontSize: "clamp(40px, 5.5vw, 78px)" }}
            >
              The
              <span className="italic font-light"> 40 / 60 </span>
              schedule.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8">
            <p className="text-[#1A3626]/75 font-light leading-relaxed">
              Capital is staged across seven installments, with 60% deferred to
              handover in March 2030. The structure preserves liquidity and
              concentrates returns on equity contributed during construction.
            </p>
          </div>
        </div>

        {/* Vertical timeline */}
        <div className="relative grid grid-cols-12 gap-6 md:gap-10">
          <div className="hidden md:block col-span-1" />
          <div className="col-span-12 md:col-span-10 relative">
            {/* spine */}
            <div className="absolute left-[14px] md:left-[18px] top-2 bottom-2 w-px bg-[#B3906A]/40" />

            {PAYMENT_SCHEDULE.map((s, i) => {
              const isHO = s.stage === "Handover Payment";
              return (
                <motion.div
                  key={s.stage}
                  data-testid={`payment-row-${i}`}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.04 }}
                  className="relative pl-12 md:pl-16 py-6 md:py-7 border-b hairline last:border-0 grid grid-cols-12 gap-4 items-center"
                >
                  <span
                    className={`absolute left-2 md:left-3 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full border ${
                      isHO
                        ? "bg-[#B3906A] border-[#B3906A]"
                        : "bg-[#F4F2EC] border-[#B3906A]"
                    }`}
                  />
                  <div className="col-span-12 sm:col-span-3 text-[11px] tracking-[0.24em] uppercase text-[#6A736E]">
                    {s.date}
                  </div>
                  <div className="col-span-8 sm:col-span-6 font-serif text-xl md:text-2xl text-[#1A3626]">
                    {s.stage}
                  </div>
                  <div className="col-span-4 sm:col-span-3 text-right font-serif text-2xl md:text-3xl text-[#1A3626]">
                    <span className={isHO ? "text-[#B3906A]" : ""}>
                      {s.percent}
                    </span>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>

        <p className="mt-10 text-xs text-[#6A736E] font-light max-w-3xl leading-relaxed">
          Indicative schedule per Modon's published 40/60 plan. ADM
          registration (2%) and admin fees apply post-booking. Full unit-level
          schedule shared on EOI confirmation.
        </p>
      </div>
    </section>
  );
}
